import { useTranslation } from 'react-i18next';
import { Box, Button, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react';

import { SortId, useDocumentSorting } from '@izimi/core';

import { CustomIcon, FeatherIcon } from '../icon';

const sortOptions = [
  {
    id: SortId.ModificationDate,
    label: 'sortingPicker.modificationDate',
  },
  {
    id: SortId.Name,
    label: 'sortingPicker.name',
  },
];

export const VaultSortingPicker = () => {
  const { t } = useTranslation('shared');
  const { activeSorting, setActiveSorting } = useDocumentSorting('vault');

  return (
    <Menu isLazy>
      <Box>
        <MenuButton
          size='sm'
          as={Button}
          rightIcon={<CustomIcon name='chevron-down' color='neutral400' size={14} />}
          bg='neutral100'>
          <Text>
            <Text as='span' display='inline-block'>
              {t(`sortingPicker.${activeSorting.id}`)}
            </Text>
          </Text>
        </MenuButton>
      </Box>
      <MenuList>
        {sortOptions.map((sortOption) => (
          <MenuItem
            key={sortOption.id}
            onClick={() => setActiveSorting({ id: sortOption.id })}
            icon={
              activeSorting.id === sortOption.id ? (
                <FeatherIcon name='check' size={18} />
              ) : undefined
            }>
            {t(sortOption.label)}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
